import React from "react";
import {useSelector, useDispatch} from "react-redux";

import loadingGif from '../../../assets/images/loader.gif';
import * as actionTypes from "../../../store/actions/actionTypes";
import bookingList from "../../../store/reducers/bookingList";
import {updateBookingStatus} from "../../../store/actions/bookingList";
import {useToasts} from "react-toast-notifications";

const TrashBooking = ({booking, onClose}) => {

    const dispatch = useDispatch();
    const {trashIds} = useSelector(state => state.bookingList);
    const {addToast} = useToasts();

    const handleAction = () => {
        dispatch(updateBookingStatus(booking, addToast, 'trashed'));
        if (onClose) onClose();
    }

    if(trashIds.indexOf(booking.id) > -1) {
        return (
            <a className="dropdown-item disabled pointer"><img src={loadingGif} alt="pointer" />Trash</a>
        );
    } else {
        return (
            <a className="dropdown-item pointer" onClick={handleAction}>Trash</a>
        );
    }
}

export default TrashBooking;